import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'
import moment from 'moment'

import OfferForm from './OfferForm'

import { updateOffer } from '../services'
import { handleError } from '../../../helpers'

export default function EditOfferModal({ visible, onClose, reload, offer }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: { 
			...offer,
			expire_at: moment(offer.expire_at).format('YYYY-MM-DD'),
			is_published: offer.is_published ? 1 : 0,
			is_selling: offer.is_selling ? 1 : 0,
		}
	})

	const onSubmit = values => {
		updateOffer(offer.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<OfferForm register={register} errors={errors} offer={offer} />
						<Button color="primary" type="submit">Actualizar Registrar</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}